module.exports = __webpack_public_path__ + "img/pc_p3_y8.304c7b38.png";